import React from 'react';

const StatsPanel = ({ stats }) => {
  const statItems = [
    { label: 'Downloads Today', value: stats.downloadsToday, unit: '' },
    { label: 'Success Rate', value: stats.successRate, unit: '%' },
    { label: 'Storage Used', value: stats.storageUsed, unit: ' GB' }
  ];

  return (
    <div className="stats-panel">
      <h3 className="section-title">📈 Stats</h3>
      <div className="stats-list">
        {statItems.map((item, index) => (
          <div key={index} className="stat-item">
            <div className="stat-label">{item.label}</div>
            <div className="stat-value">
              {item.value}{item.unit}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsPanel;


